export const portfolioImages = {
  hero: {
    anatomie:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/banners/anatomie.webp",
    frank:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/banners/frank-hero.webp",
    openn:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/banners/openn.webp",
    rxnt: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/rxnt/rxnt-hero.webp",
    svhs: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/banners/svhs-hero.webp",
    tds: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/banners/tds.webp",
    tynax:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/banners/tynax.webp",
    vacsewcenter:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/banners/vacsewcenter.webp",
    wbes: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/banners/wbes.webp",
    willship:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/banners/willship.webp",
  },
  mockup: {
    anatomie:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/anatomie-mockup.webp",
    frank:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/frank-mockup.webp",
    openn:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/openn-mockup.webp",
    rxnt: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/rxnt-mockup.webp",
    svhs: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/svhs-mockup.webp",
    tds: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/tds-mockup.webp",
    tynax:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/tynax-mockup.webp",
    vacsewcenter:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/vacsewcenter-mockup.webp",
    wbes: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/wbes-mockup.webp",
    willship:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/willship-mockup.webp",
  },
  technology: {
    anatomie:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/anatomie/anatomie.webp",
    frank:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/frank/frank.webp",
    openn:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/openn/openn.webp",
    rxnt: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/rxnt/rxnt-technology.webp",
    svhs: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/svhs/svhs.webp",
    tds: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/tds/tds.webp",
    tynax:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/tynax/tynax.webp",
    vacsewcenter:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/vacsewcenter/vacsewcenter.webp",
    wbes: "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/wbes/wbes.webp",
    willship:
      "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/portfolio/willship/willship.webp",
  },
};
